import React, { Component } from "react";
import { connect } from "react-redux";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import Button from "../../../button-classic/button-classic";
import ACTIONS from "../../../../common/action_constant";
import AddSupplierItemMaster from "./add-supplier-item-master";

class SupplierItemMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 10,
      isOpen: false,
      editData: null,
      listData: [],
    };
  }

  componentDidMount() {
    this.getSupplierItemMasterData();
  }

  getSupplierItemMasterData = () => {
    const { dispatch, companyId } = this.props;
    const { offset, limit } = this.state;
    const param = `?companyId=${companyId}&limit=${limit}&offset=${offset}`;

    dispatch({
      type: ACTIONS.PLANTS.GET_SUPPLIER_ITEM_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ listData: res || [] });
      },
    });
  };

  toggleAdd = () => {
    this.setState({ isOpen: !this.state.isOpen, editData: null });
  };

  editSupplierItemMaster = (item) => {
    this.setState({ isOpen: true, editData: item });
  };

  deleteSupplierItemMaster = (item) => {
    const { dispatch, companyId } = this.props;

    dispatch({
      type: ACTIONS.PLANTS.DELETE_SUPPLIER_ITEM_MASTER,
      data: {
        company_id: companyId,
        master_id: item.master_id,
      },
      onSuccess: () => {
        this.getSupplierItemMasterData();
      },
    });
  };

  next = () => {
    this.setState(
      (prevState) => ({ offset: prevState.offset + prevState.limit }),
      this.getSupplierItemMasterData
    );
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({ offset: prevState.offset - prevState.limit }),
        this.getSupplierItemMasterData
      );
    }
  };

  render() {
    const { listData } = this.state;
    const { companyId, dispatch } = this.props;

    return (
      <div className="location-network">
        <div style={{ paddingBottom: "15px" }}>
          <Button value="+ Add Supplier Item" click={this.toggleAdd} />
        </div>

        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Item Numbers</th>
              <th>Process Points</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {listData.length > 0 ? (
              listData.map((item, index) => (
                <tr key={item.master_id || index}>
                  <td>{item.item_name}</td>
                  <td>{(item.item_numbers || []).join(", ")}</td>
                  <td>{(item.process_points_details || []).length} points</td>
                  <td>
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Edit})` }}
                      onClick={() => this.editSupplierItemMaster(item)}
                    />
                    <div
                      className="action-icon"
                      style={{ backgroundImage: `url(${Delete})` }}
                      onClick={() => this.deleteSupplierItemMaster(item)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>

        {this.state.isOpen && (
          <AddSupplierItemMaster
            toggleAdd={this.toggleAdd}
            editData={this.state.editData}
            companyId={companyId}
            dispatch={dispatch}
            refreshData={this.getSupplierItemMasterData}
          />
        )}
      </div>
    );
  }
}

export default connect()(SupplierItemMaster);
